import jsonLogic from "json-logic-js";

export default function (){
    this.main.conditionalRequired = function conditionalRequired(cb){
        let required = jsonLogic.apply(this.rule.rule, this.model);
        if(required){
            if(!this.source.hasOwnProperty(this.field) || this.value === undefined){
                this.raise(this.reasons.required,
                    this.messages.required, this.field);
            }
        }
        cb();
    };

    this.isRequiredIf = function isRequiredIf(){
        if(this.rule.required){
            return this.rule.required;
        }
        if(!this.rule.hasOwnProperty("requiredIf")){
            return false;
        }
        let required = this.rule.requiredIf;
        if(typeof required === "object"){
            required = jsonLogic.apply(required, this.source);
        }
        return required;
    };
};
